import React from 'react';
import PropTypes from 'prop-types';

const ModalTitle = props => (
    <h1 className="modal__title" id="dialog-title">{props.children}</h1>
);

ModalTitle.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

ModalTitle.defaultProps = {
    children: null,
};

export default ModalTitle;
